var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('amisEditor',{attrs:{"id":"editorName","theme":"cxd","className":"is-fixed","preview":_vm.isPreview,"isMobile":_vm.isMobile,"value":_vm.schema},on:{"onChange":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }